module.exports = __webpack_public_path__ + "static/media/profile-action-needed.07529294.svg";